export enum UserTier {
  FREE = 'free',
  STARTER = 'starter',
  ADMIN = 'admin'
}